'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var bent = require('bent');
var ethers = require('ethers');
var ramda = require('ramda');
var urljoin = require('url-join');
var axios = require('axios');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var bent__default = /*#__PURE__*/_interopDefaultLegacy(bent);
var urljoin__default = /*#__PURE__*/_interopDefaultLegacy(urljoin);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function mine(provider, count) {
    return __awaiter(this, void 0, void 0, function* () {
        const counter = Array.from(Array(count).keys());
        // eslint-disable-next-line functional/functional-parameters
        const mine = () => __awaiter(this, void 0, void 0, function* () {
            yield provider.send('evm_mine', []);
        });
        yield Promise.all(counter.map(mine));
    });
}

const blockchain = { mine };

const createEGSFetcher = (fetcher) => () => __awaiter(void 0, void 0, void 0, function* () { return fetcher('').then((r) => r); });
const ethGasStationFetcher = (token, speed = 'fastest') => ((egs) => () => __awaiter(void 0, void 0, void 0, function* () {
    return egs().then((res) => {
        const gas = speed === 'fastest'
            ? res.fastest
            : speed === 'fast'
                ? res.fast
                : speed === 'average'
                    ? res.average
                    : speed === 'safeLow'
                        ? res.safeLow
                        : 0;
        return ethers.utils.parseUnits(`${gas / 10}`, 'gwei').toString();
    });
}))(createEGSFetcher(bent__default['default'](`https://ethgasstation.info/api/ethgasAPI.json?api-key=${token}`, 'json')));

const gas = { ethGasStationFetcher };

const whenDefined = (depends, fn) => ramda.cond([
    [ramda.isNil, ramda.always(undefined)],
    [ramda.T, (deps) => fn(deps)],
])(depends);

const isNotNil = (t) => ramda.complement(ramda.isNil)(t);

const passAll = (depends) => depends instanceof Array ? depends.every(isNotNil) : isNotNil(depends);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function whenDefinedAll(depends, fn) {
    return whenDefined(depends, ramda.cond([
        [passAll, (deps) => fn(deps)],
        [ramda.T, ramda.always(undefined)],
    ]));
}

const utils = { whenDefined, whenDefinedAll };

const getTextUrls = (twitterId) => __awaiter(void 0, void 0, void 0, function* () {
    const twitterUrl = urljoin__default['default']('https://api.twitter.com/2/tweets', twitterId);
    const programmableProxyUrl = urljoin__default['default']('https://programmable-proxy.azureedge.net', `?s=${twitterUrl}?tweet.fields=entities`);
    const res = yield axios__default['default'].get(programmableProxyUrl);
    const isStatusGreen = res.status === 200;
    const urls = isStatusGreen ? res.data.data.entities.urls : [];
    const expandedUrls = urls.map((info) => {
        return info.expanded_url;
    });
    const unwoundUrls = urls.map((info) => {
        return info.unwound_url;
    });
    return [isStatusGreen, Array.from(new Set(expandedUrls.concat(unwoundUrls)))];
});

const twitter = { getTextUrls };

const toBigNumber = (v) => ethers.BigNumber.from(v);

exports.blockchain = blockchain;
exports.ethGasStationFetcher = ethGasStationFetcher;
exports.gas = gas;
exports.getTextUrls = getTextUrls;
exports.isNotNil = isNotNil;
exports.mine = mine;
exports.toBigNumber = toBigNumber;
exports.twitter = twitter;
exports.utils = utils;
exports.whenDefined = whenDefined;
exports.whenDefinedAll = whenDefinedAll;
